import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e9330e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pair" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "name" };
const _hoisted_4 = { class: "main_currency" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, " / ", -1));
const _hoisted_6 = { class: "base_currency" };
import { useStore } from '@/store/store';
import { ref } from 'vue';
import { decimalizeByExchange } from '@/logics/utils';
import NoData from '@/materials/atoms/NoData.vue';
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const currentPair = ref(store.getters.symbol.pair);
        const onClick = (pair, base, quote) => {
            currentPair.value = pair;
            emit('click', { pair, base, quote });
        };
        const setColor = (change) => {
            if (change < 0) {
                return 'var(--trade-order-short)';
            }
            if (change > 0) {
                return 'var(--trade-order-long)';
            }
            if (change === 0) {
                return 'var(--primary-font-color)';
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["list", currentPair.value === item.pair ? 'selected' : '']),
                        key: index,
                        onClick: ($event) => (onClick(item.pair, item.base, item.quote))
                    }, [
                        _createVNode(CryptoIcon, {
                            class: "crypto_icon",
                            base: item.base.toLowerCase(),
                            width: 16
                        }, null, 8, ["base"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(item.base), 1),
                            _hoisted_5,
                            _createElementVNode("span", _hoisted_6, _toDisplayString(item.quote), 1)
                        ]),
                        _createElementVNode("div", {
                            class: "content",
                            style: _normalizeStyle(`color: ${setColor(Number(item === null || item === void 0 ? void 0 : item.volatility))}`)
                        }, _toDisplayString(Number(item.price) ? _unref(decimalizeByExchange)(Number(item.price), item.pair, _unref(store).state.currencyPairInfo) : '---'), 5),
                        _createElementVNode("div", {
                            class: "change",
                            style: _normalizeStyle(`color: ${setColor(Number(item === null || item === void 0 ? void 0 : item.volatility))}`)
                        }, _toDisplayString(Math.ceil(Number((item === null || item === void 0 ? void 0 : item.volatility) || 0) * 100) / 100) + " % ", 5)
                    ], 10, _hoisted_2));
                }), 128)),
                _createVNode(NoData, {
                    isShow: props.list.length === 0
                }, null, 8, ["isShow"])
            ]));
        };
    }
});
